import React, { Suspense } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import { ObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/ObjectsUIContext';
import { StimulSoftViewer } from '../../customComponents/stimulReport/StimulSoftViewer';




const ReportTestPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.groups }),
    shallowEqual
  );

  // let isFullAccess = false;
  // const { menuList } = useSelector(
  //   (state) => ({ menuList: state.auth.menu }),
  //   shallowEqual
  // );

  // if (menuList.find(q => q.url == "/testReport")) {
  //   const temp = menuList.find(q => q.url == "/testReport")
  //   isFullAccess = temp.isFullAccess;
  // }

  return (
    <FilterObjectsUIProvider >
      <StimulSoftViewer mrtUrl='/reports/GetPlacesReport.mrt' currentState={currentState} api="api/group" />
    </FilterObjectsUIProvider>
  )
}

export default ReportTestPage



